// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import posthog from "posthog-js"
import "./controllers"
import "./base/base"

// Token is a public write-only key, safe to ship in client JS.
const posthogToken = window.deskedGlobals && window.deskedGlobals.posthogToken
if (posthogToken) {
  posthog.init(posthogToken, {
    api_host: "https://v.desked.io", // managed reverse proxy domain
    ui_host: "https://us.posthog.com", // proxy means links need this to point back to PostHog properly
    person_profiles: "identified_only"
  })

  const login = window.deskedGlobals.login
  if (login) posthog.identify(login)
}

// Turbo Drive is ON (F-15). Per-view bundles init via onPageLoad (base/pageLoad.js),
// which keys off turbo:load and gates on <body data-view> — so SPA-style body swaps
// re-run the right page's init instead of the old DOMContentLoaded that only fired
// on full loads. No Turbo Streams/Frames in use. `data-turbo-track="reload"` on the
// layout's app/vendor tags still forces a full reload when a deploy ships new assets.
void Turbo
